import React from 'react';
import dynamic from 'next/dynamic';
import MobileDetect from 'mobile-detect';
import PATHS from 'lib/navigation/paths';
import generateHreflang from 'lib/utils/generateHreflang';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
// import useDetectSlugsCSR from 'views/common/hooks/useDetectSlugsCSR';
import isCrawlers from 'lib/utils/isCrawlers';
import { API } from 'lib/config/axios';
import { serverFetch } from 'lib/utils/serverFetch';
import { handleDetectSlugsSSR } from 'lib/utils/handleDetectSlugsSSR';
import { TOUR_TYPES, SLUGS_TYPES } from 'lib/utils/CONSTANTS';
import { HydrationWrapper } from 'views/common/components';
import { ID_TYPES } from 'views/rebranded-module/tours-module/ToursListingViewV2/utils/constants';
import { prepareTranslationFiles } from 'views/tours-module/utils/prepareTranslationFiles';
import getLocalizedUrl from 'lib/utils/getLocalizedUrl';
import translateUrlSSR from 'lib/utils/translateUrlSSR';
import { useSelector } from 'react-redux';
import { checkIfUrlHasCorrectSegmentsTranslations } from 'lib/utils/checkIfUrlHasCorrectSegmentsTranslations';
import generateToursListingHreflangs from 'views/tours-module/utils/generateToursListingHreflangs';
import { ErrorPageV2 } from 'views/rebranded-module/common/components';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';
import { useToursListingCMSData } from 'views/rebranded-module/tours-module/ToursListingViewV2/hooks/useToursListingCMSData';
import { cmsServerFetch } from 'lib/utils/cmsServerFetch';
import { toursLandingPageCmsQuery } from 'views/rebranded-module/tours-module/ToursLandingViewV2/utils/toursLandingPageCmsQuery';

const ToursListingViewV2 = dynamic(() => import('views/rebranded-module/tours-module/ToursListingViewV2').then(
  (file) => file.ToursListingViewV2,
));
const ToursLandingViewV2 = dynamic(() => import('views/rebranded-module/tours-module/ToursLandingViewV2').then(
  (file) => file.ToursLandingViewV2,
));

const ToursListingPage = (props) => {
  const {
    serverData,
    ssrRender,
    detectSlugsSSRData,
    initWidgetData,
    serverError,
    cmsData,
  } = props;

  const appNavigator = useAppNavigator();
  const isCrawler = useSelector((state) => state.globalData.isCrawler);
  const toursListingContent = useToursListingCMSData();

  // const detectSlugsReqBody = {
  //   slugs: [
  //     {
  //       slug: appNavigator.query.slug,
  //       expected_types: [
  //         SLUGS_TYPES.country,
  //         SLUGS_TYPES.location,
  //         SLUGS_TYPES.region,
  //         SLUGS_TYPES.market,
  //       ],
  //     },
  //   ],
  // };

  // const [slug, loadingSLug, handleSlugTypeChange] = useDetectSlugsCSR(
  //   detectSlugsSSRData?.slugSSR,
  //   appNavigator.query.slug,
  //   detectSlugsReqBody,
  //   PATHS.guidedTour,
  //   [appNavigator.query.slug],
  // );

  const renderPageView = () => {
    if (serverError) {
      return <ErrorPageV2 statusCode={serverError.statusCode} />;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (appNavigator.query.hasOwnProperty('q') || appNavigator.query.slug) {
      return (
        <ContentContext.Provider value={toursListingContent.data}>
          <ToursListingViewV2
            serverData={serverData}
            ssrRender={ssrRender}
            tourType={TOUR_TYPES.ALL}
            // handleSlugTypeChange={handleSlugTypeChange}
            slugData={detectSlugsSSRData?.slugSSR}
          />
        </ContentContext.Provider>
      );
    }
    return (
      <ContentContext.Provider value={cmsData}>
        <ToursLandingViewV2
          serverData={serverData}
          initWidgetData={initWidgetData}
        />
      </ContentContext.Provider>
    );
  };

  if (isCrawler) {
    return <HydrationWrapper>{renderPageView()}</HydrationWrapper>;
  }
  return <>{renderPageView()}</>;
};

export async function getServerSideProps(ctx) {
  let hreflangData = null;
  const url = ctx.query.slug
    ? PATHS.motorcycleTours.slug(ctx.query.slug).url
    : PATHS.motorcycleTours.index().url;
  hreflangData = generateHreflang(url, ctx.locale);

  const userAgent = ctx.req.headers['user-agent'];
  const ssrRender = isCrawlers(userAgent);
  let layoutData = null;
  let serverData = null;
  let detectSlugsSSRData = null;
  let serverError = null;
  let redirectURL = null;
  let initWidgetData = null;
  let cmsData = null;
  const translation = await prepareTranslationFiles(ctx, TOUR_TYPES.ALL);
  const options = {
    showAiChat: true,
    transparentNavBar: true,
    staticNavBar: false,
  };
  const pageRequests = () => {
    if (ctx.query.slug) {
      options.staticNavBar = true;
      return [
        serverFetch(ctx, API.layout, ctx.query),
        serverFetch(ctx, API.tours.index, {
          [ID_TYPES[detectSlugsSSRData.slugSSR.slugs[0].slug_type]]:
            detectSlugsSSRData.slugSSR.slugs[0].resource_id,
          q: ctx.query.q,
          preferred_seo_identifer: new URL(hreflangData.canonical).pathname,
        }),
      ];
    }

    // eslint-disable-next-line no-prototype-builtins
    if (ctx.query.hasOwnProperty('q')) {
      options.staticNavBar = true;
      return [
        serverFetch(ctx, API.layout, ctx.query),
        serverFetch(ctx, API.tours.index, {
          q: ctx.query.q,
          preferred_seo_identifer: new URL(hreflangData.canonical).pathname,
        }),
      ];
    }

    return [
      serverFetch(ctx, API.layout, ctx.query),
      serverFetch(ctx, API.tours.home, {
        preferred_seo_identifer: new URL(hreflangData.canonical).pathname,
      }),
      cmsServerFetch(ctx, toursLandingPageCmsQuery),
    ];
  };

  const handlePageRequests = async () => {
    const [layoutRes, pageResponse, widgetRes] = await Promise.all(
      pageRequests(),
    );
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
      if (widgetRes?.success && widgetRes?.data) {
        initWidgetData = widgetRes.data;
      }
      if (pageResponse.success && pageResponse.data) {
        serverData = pageResponse.data;
      } else {
        const { error } = pageResponse;
        switch (error?.response?.status) {
          case 403:
            if (error.response.data.error_code === 'ER0001') {
              redirectURL = {
                destination: getLocalizedUrl(
                  translateUrlSSR(
                    PATHS.motorcycleTours.index().url,
                    ctx.locale,
                  ),
                  ctx.locale,
                  true,
                ),
                permanent: true,
              };
            } else {
              serverError = {
                statusCode: pageResponse.error.response.status,
              };
            }
            break;
          case 400:
            // eslint-disable-next-line no-case-declarations
            redirectURL = {
              destination: getLocalizedUrl(
                translateUrlSSR('/motorcycle-tours?q=', ctx.locale),
                ctx.locale,
              ),
              permanent: true,
            };
            break;
          default:
            serverError = {
              statusCode: pageResponse.error.response.status,
            };
        }
      }
    } else {
      ctx.res.statusCode = 503;
    }

    // Handle CMS data for landing page
    if (widgetRes && !ctx.query.slug && !('q' in ctx.query)) {
      if (widgetRes?.success) {
        cmsData = widgetRes.cmsData;
      } else {
        const statusCode = widgetRes?.error?.response?.status || widgetRes?.status || 500;
        if (!serverError) {
          serverError = {
            statusCode,
          };
        }
      }
    }
  };

  if (ctx.query.slug) {
    detectSlugsSSRData = await handleDetectSlugsSSR(
      ctx,
      {
        slugs: [
          {
            slug: ctx.query.slug,
            expected_types: [
              SLUGS_TYPES.country,
              SLUGS_TYPES.location,
              SLUGS_TYPES.region,
              SLUGS_TYPES.market,
            ],
          },
        ],
      },
      PATHS.motorcycleTours.slug,
    );
    if (detectSlugsSSRData.newPath) {
      return {
        redirect: {
          destination: detectSlugsSSRData.newPath,
          permanent: true,
        },
      };
    }
    if (!detectSlugsSSRData.renderErrorPage) {
      await handlePageRequests();
      if (serverData?.tours?.length === 0) {
        ctx.res.setHeader('X-Robots-Tag', 'noindex');
      }
    } else {
      ctx.res.statusCode = 404;
      serverError = {
        statusCode: 404,
      };
      return {
        props: {
          ...translation,
          serverError,
        },
      };
    }
  } else {
    await handlePageRequests();
  }

  if (redirectURL) {
    return { redirect: redirectURL };
  }

  let deviceType;
  const md = new MobileDetect(userAgent);
  if (md.tablet()) {
    deviceType = 'tablet';
  } else if (md.mobile()) {
    deviceType = 'mobile';
  } else {
    deviceType = 'desktop';
  }

  if (serverError) {
    ctx.res.statusCode = serverError?.statusCode;
  }

  if (serverData) {
    hreflangData = generateToursListingHreflangs(url, ctx.locale, serverData);
  }

  const isCorrectSegemntTranslation = checkIfUrlHasCorrectSegmentsTranslations(
    ctx,
    hreflangData.canonical,
  );
  if (isCorrectSegemntTranslation.shouldRedirect) {
    return {
      redirect: {
        destination: isCorrectSegemntTranslation.redirectURL,
        permanent: true,
      },
    };
  }

  return {
    props: {
      layoutData,
      serverData,
      initWidgetData,
      cmsData,
      ...translation,
      hreflangData,
      ssrRender,
      serverError: serverError || null,
      deviceType,
      detectSlugsSSRData,
      options,
      rebrandingPage: true,
    },
  };
}
export default ToursListingPage;
